/*
 * @Author: Hancle
 * @Date: 2019-07-22 17:32:59
 * @Last Modified by: Hancle
 * @Last Modified time: 2019-07-29 14:52:37
 */
import Vue from "vue";
import { Toast, Dialog, createAPI } from "cube-ui";
createAPI(Vue, Toast, true);
createAPI(Vue, Dialog, true);
const isString = (value)=>{
  return Object.prototype.toString.call(value) == '[object String]';
};

const $toast = {
  /**
   * cube  loading
   * 参数：
   * 可不传参，直接调用
   * {
        time: 时间毫秒(默认300000,即5分钟),
        txt: 文字,
        mask: 是否启用蒙层(默认关闭),
        hide:是否关闭
      }
   */
  loading: (function() {
    return function(config) {
      config = config ? config : {};
      if (config.hide) {
        window._Toastloding && window._Toastloding.hide();
        try{
          document.querySelectorAll('.cube-toast').forEach(elem=>{
              elem.style.display = 'none';
          })
        }catch(err){
          console.error(err)
        }
      } else {
        window._Toastloding = Toast.$create(
          {
            time: config.time ? config.time : 300000,
            txt: config.txt,
            mask: config.mask
          },
          () => {}
        );
        window._Toastloding.show();
      }
    };
  })(),

  /**
   * cube  toast
   * 参数：
   * {
        time: 时间毫秒(默认2000),
        txt: 文字,
        mask: 是否启用蒙层(默认关闭),
        hide:是否关闭,默认false,
        type:默认为txt（loading/correct/error/warn/txt）,
        maskClosable:点击蒙层是否隐藏,默认false,
        zIndex:z-index 数值，默认900,
        fn:toast 结束后触发函数(触发条件 ：必须是时间自然结束，手动关闭toast不触发函数)
      }
   */
  toast: (function() {
    return function(config) {
      config = config ? config : {};
      if(isString(config)){
        config = {
          txt: config
        }
      }
      let defaultConfigTime = config.time ? config.time : 2000;
      window._ToastTip = Toast.$create(
        {
          time: defaultConfigTime,
          txt: config.txt,
          mask: config.mask,
          type: config.type ? config.type : "txt",
          maskClosable: config.maskClosable ? config.maskClosable : false,
          zIndex: config.zIndex ? config.zIndex : 900,
          $events: {
            timeout: () => {
              config.fn && config.fn();
            }
          }
        },
        () => {}
      );
      
        window._ToastTip.show();
        if(window._ToastTime) clearTimeout(window._ToastTime)
        window._ToastTime = setTimeout(()=>{
          try{
            document.querySelectorAll('.cube-toast').forEach(elem=>{
                elem.style.display = 'none';
            })
          }catch(err){
            console.error(err)
          }
        }, defaultConfigTime);

    };
  })(),

  /**
   * cube  error
   * 参数：
   * {
        time: 时间毫秒(默认2000),
        txt: 文字,
        mask: 是否启用蒙层(默认关闭),
        hide:是否关闭,默认false,
        type:error,
        maskClosable:点击蒙层是否隐藏,默认false,
        zIndex:z-index 数值，默认900,
        fn:toast 结束后触发函数(触发条件 ：必须是时间自然结束，手动关闭toast不触发函数)
      }
   */
  toasterr: function(err) {
    // return function(config) {
    //   config = config ? config : {};
    //   var toastC = Toast.$create(
    //     {
    //       time: config.time ? config.time : 2000,
    //       txt: config.txt,
    //       mask: config.mask,
    //       type: "error",
    //       maskClosable: config.maskClosable ? config.maskClosable : false,
    //       zIndex: config.zIndex ? config.zIndex : 900,
    //       $events: {
    //         timeout: () => {
    //           config.fn && config.fn();
    //         }
    //       }
    //     },
    //     () => {}
    //   );
    //   if (config.hide) {
    //     toastC.hide();
    //   } else {
    //     toastC.show();
    //   }
    // };

    let text = '请求失败';
    if(isString(err)){
      text = err
    }else{
      if(err && err.response && err.response.data && err.response.data.info){
        text = err.response.data.info;
      }
    }
    return this.toast({txt: text})

  },

  /**
   * 默认alert弹窗
   * 参数：
   *  config 类型：Object
   *    type: 类型 提示框 alert / 确认框 confirm / 提示输入框 prompt, 默认为alert
   *    title：标题
   *    content： 正文
   *    confirmBtn： 确认按钮参数配置,默认为“确定”	(text: 按钮文案, active:是否高亮, disabled:是否禁用, href:点击按钮后的跳转链接	)
   *    cancelBtn: 取消按钮参数配置,默认为不显示	(text: 按钮文案, active:是否高亮, disabled:是否禁用, href:点击按钮后的跳转链接	)
   *    onConfirm： 确定按钮回调函数
   *    onCancel： 取消按钮回调函数
   *
   *    zIndex: 默认为10000
   *    更多配置可以参考：https://didi.github.io/cube-ui/#/zh-CN/docs/dialog
   */
  alert: (function() {
    return function(config) {
      if (!config) return;
      let dialogConfig = Object.assign(
        {
          type: "alert",
          zIndex: 10000
        },
        config
      );
      Dialog.$create(dialogConfig).show();
    };
  })()
};

export default $toast;



// WEBPACK FOOTER //
// ./src/lib/toast.js